import React from "react";


const WebAlert = (props) => {
    const handleClickOK = () => {
        if(props?.action) {
            props.action();
        }
        props?.setShowWebAlert(false);
    };
    return (
      <div style={{ display: (props?.show || props.isOpen) ? 'block' : 'none' }} className='alert-modal-container'>
        <div className="alert-modal-overlay" onClick={() => props?.setShowWebAlert(false)}></div>
        <div className="alert-modal">
            <div className="alert-modal-header">
                <h2 className="lucky-font">{props.title}</h2>
                <button className="alert-modal-close-button" onClick={() => props?.setShowWebAlert(false)}>💩</button>
            </div>
            <div className='alert-modal-body lato-font'>
                <p>{props.message}</p>
                <button className="alert-modal-ok-button" onClick={handleClickOK}>OK</button>
            </div>
        </div>
    </div>
    );

}

export default WebAlert;